<template>
  <div class="isLink">
    <router-link to="/" @click="setNavigator()">
      <span class="material-icons">dashboard</span>
      <span>Dashboard</span>
      <span></span>
    </router-link>
  </div>
  <div v-for="(item, key) in menu" :key="key">
    <div class="isLink" v-if="item.url && shouldDisplayMenuItem(item)">
      <router-link :to="'/' + $t(item.url)" @click="setNavigator()" :class="{ 'router-link-active': isDirectLinkActive(item) }">
        <span class="material-icons">{{ item.icon }}</span>
        <span>{{ $t(item.label) }}</span>
        <span></span>
      </router-link>
    </div>
    <div
      class="section-link cdlMenu"
      :class="['cdlMenu-' + key]"
      @click="ctlMobileMenuOne(key)"
      v-else-if="shouldDisplayMenuItem(item)"
    >
      <span class="material-icons">{{ item.icon }}</span>
      <span>{{ $t(item.label) }}</span>
      <span class="material-icons menuArrow" :class="{ active: item.open }" aria-hidden="true">keyboard_arrow_down</span>
    </div>
    <div v-if="item.child" class="subMenuGroup" :class="{ open: item.open }">
      <div class="subMenuGroupInner">
        <div
          v-for="(levelOne, kOne) in filteredLevelOne(item.child)"
          :key="kOne"
          class="subMenu"
          :class="{ isLink: levelOne.url }"
        >
          <router-link
            v-if="levelOne.url && shouldDisplayMenuItem(levelOne)"
            :to="'/' + $t(levelOne.url)"
            class="mdl-navigation__link cdlMenu"
            @click="setNavigator($t(levelOne.url))"
            >{{ $t(levelOne.label) }}</router-link
          >
          <div v-else-if="shouldDisplayMenuItem(levelOne)">
            <div class="cdlMenu" @click="ctlMobileMenuTwo(key, kOne)">
              <span>{{ $t(levelOne.label) }}</span>
              <span class="material-icons menuArrow" :class="{ active: levelOne.open }" aria-hidden="true" v-if="levelOne.child">keyboard_arrow_down</span>
            </div>

            <div v-if="levelOne.child" class="subMenuGroup" :class="{ open: levelOne.open }">
              <div class="subMenuGroupInner">
                <div
                  v-for="(levelTwo, kTwo) in filteredLevelTwo(levelOne.child)"
                  :key="kTwo"
                  class="subMenu"
                  :class="{ isLink: levelTwo.url }"
                >
                  <router-link
                    v-if="levelTwo.url && shouldDisplayMenuItem(levelTwo)"
                    :to="'/' + $t(levelTwo.url)"
                    class="mdl-navigation__link"
                    @click="setNavigator($t(levelTwo.url))"
                    >{{ $t(levelTwo.label) }}</router-link
                  >
                  <div v-else-if="shouldDisplayMenuItem(levelTwo)">
                    <div
                      class="cdlMenu"
                      @click="ctlMobileMenuThree(key, kOne, kTwo)"
                    >
                      <span>{{ $t(levelTwo.label) }}</span>
                      <span
                        class="material-icons menuArrow"
                        :class="{ active: levelTwo.open }"
                        aria-hidden="true"
                        v-if="levelTwo.child"
                        >keyboard_arrow_down</span
                      >
                    </div>
                    <div v-if="levelTwo.child" class="subMenuGroup" :class="{ open: levelTwo.open }">
                      <div class="subMenuGroupInner">
                        <div
                          v-for="(levelThree, kThree) in filteredLevelThree(
                            levelTwo.child
                          )"
                          :key="kThree"
                          class="subMenu"
                          :class="{ isLink: levelThree.url }"
                        >
                          <router-link
                            v-if="levelThree.url && shouldDisplayMenuItem(levelThree)"
                            :to="'/' + $t(levelThree.url)"
                            class="mdl-navigation__link cdlMenu"
                            @click="setNavigator($t(levelThree.url))"
                            >{{ $t(levelThree.label) }}</router-link
                          >
                          <div v-else-if="shouldDisplayMenuItem(levelThree)">
                            <div
                              class="cdlMenu"
                              @click="ctlMobileMenuFour(key, kOne, kTwo, kThree)"
                            >
                              <span>{{ $t(levelThree.label) }}</span>
                              <span
                                class="material-icons menuArrow"
                                :class="{ active: levelThree.open }"
                                aria-hidden="true"
                                v-if="levelThree.child"
                                >keyboard_arrow_down</span
                              >
                            </div>
                            <div v-if="levelThree.child" class="subMenuGroup" :class="{ open: levelThree.open }">
                              <div class="subMenuGroupInner">
                                <div
                                  v-for="(levelFour, kFour) in filteredLevelFour(
                                    levelThree.child
                                  )"
                                  :key="kFour"
                                  class="subMenu"
                                  :class="{ isLink: levelFour.url }"
                                >
                                  <router-link
                                    v-if="
                                      levelFour.url && shouldDisplayMenuItem(levelFour)
                                    "
                                    :to="'/' + $t(levelFour.url)"
                                    class="mdl-navigation__link cdlMenu"
                                    @click="setNavigator($t(levelFour.url))"
                                    >{{ $t(levelFour.label) }}</router-link
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="privacyPolicy">
    <span class="elmMenu"
      ><a :href="this.linkToPrivacyPolicy" target="_blank"
        >Privacy Policy</a
      ></span
    >
  </div>
</template>

<script>
import menuJson from "@/configs/menu.json";
import { useMenuAutoExpand } from "@/composables/menu/useMenuAutoExpand";
import { shouldDisplayMenuItem, hasPermissionForMenuItem } from "@/utils/menuUtils";

export default {
  name: "MenuMobile",
  props: ["text", "lang", "user"],
  // opzione setup() e non <script setup>: il template usa `this.` e in produzione con script setup sarebbe undefined
  setup() {
    // gruppi aperti sul ramo della pagina corrente (anche arrivando da un quick connect)
    useMenuAutoExpand(menuJson);
  },
  data() {
    return {
      menu: menuJson,
      userLanguage: "",
    };
  },
  computed: {
    linkToPrivacyPolicy() {
      const IT_LANG = "it";
      return this.userLanguage === IT_LANG
        ? "https://www.cdlan.it/informativa-privacy-ai-clienti"
        : "https://www.cdlan.it/en/privacy-policy-for-customers";
    },
  },
  methods: {
    shouldDisplayMenuItem,
    hasPermissionForMenuItem,
    isDirectLinkActive(item) {
      return this.$i18n.availableLocales.some(
        (locale) => this.$route.path === "/" + this.$t(item.url, {}, { locale })
      );
    },
    filteredLevelOne(children) {
      return children.filter((child) => this.shouldDisplayMenuItem(child));
    },
    filteredLevelTwo(children) {
      return children.filter((child) => this.shouldDisplayMenuItem(child));
    },
    filteredLevelThree(children) {
      return children.filter((child) => this.shouldDisplayMenuItem(child));
    },
    filteredLevelFour(children) {
      return children.filter((child) => this.shouldDisplayMenuItem(child));
    },
    ctlMobileMenuOne(key) {
      this.menu[key].open = !this.menu[key].open;
    },
    ctlMobileMenuTwo(key, kOne) {
      this.menu[key].child[kOne].open = !this.menu[key].child[kOne].open;
    },
    ctlMobileMenuThree(key, kOne, kTwo) {
      this.menu[key].child[kOne].child[kTwo].open =
        !this.menu[key].child[kOne].child[kTwo].open;
    },
    ctlMobileMenuFour(key, kOne, kTwo, kThree) {
      this.menu[key].child[kOne].child[kTwo].child[kThree].open =
        !this.menu[key].child[kOne].child[kTwo].child[kThree].open;
    },
    setNavigator() {
      this.$emit("closeMenu");
    },
  },
  watch: {
    lang: {
      handler(newValue) {
        this.userLanguage = newValue;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
